import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useProfileScopeQuery } from '@syf-api-library/profile';
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Button as SyfButton } from 'syf-component-library/ui/atoms';
import useConfig from '../../context/config.context';
import useSteps from '../../context/steps.context';
import useAccountSummary from '../../hooks/useAccountSummary';
import useCardEligibilityQuery from '../../hooks/useCardEligibility';
import useHandlers from '../../hooks/useHandlers';
import { useReplaceMultipleCardsQuery } from '../../hooks/useReplaceCardQuery';
import { t } from '../../translations/getTranslation';
const FooterWrapper = styled.div `
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small}px;
  padding: ${({ theme }) => theme.spacing.base}px;

  @media ${query.greaterThanMedium} {
    padding: ${({ theme }) => theme.spacing.large}px;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.medium}px;

    & :nth-child(1) {
      order: 2;
    }
  }
`;
const Button = styled(SyfButton) `
  margin: unset;
  height: unset;

  padding: ${({ theme: { spacing } }) => `${spacing.medium}px ${spacing.large}px`};
`;
const useFooter = () => {
    const { stepsState: { activeStep, isRequestLoading } } = useSteps();
    const { config, accountId } = useConfig();
    const isReviewStep = activeStep === 'ReviewDamagedCard';
    /* Handle step up auth scenario where no footer should be shown */
    const { isInitialLoading, isLoading: isProfileScopeLoading, error } = useProfileScopeQuery({
        config,
        keyProps: { accountId, accountIdType: 'guid' },
        queryOptions: {
            enabled: isReviewStep
        }
    });
    const { isLoading: isReplaceMultipleCardsLoading } = useReplaceMultipleCardsQuery();
    const { isLoading: cardEligibilityLoading } = useCardEligibilityQuery();
    const { isLoading: isAccountSummaryLoading } = useAccountSummary();
    const shouldNotRender = isInitialLoading ||
        isProfileScopeLoading ||
        isReplaceMultipleCardsLoading ||
        cardEligibilityLoading ||
        isAccountSummaryLoading ||
        /* Handles not showing while redirecting */
        (isReviewStep && (error === null || error === void 0 ? void 0 : error.response.status) === 403) ||
        isRequestLoading;
    return { shouldNotRender };
};
const ModalFooter = () => {
    const { stepsState: { activeStep, handleProfileClick } } = useSteps();
    const { accountId } = useConfig();
    const { shouldNotRender } = useFooter();
    const { primaryTextKey, primaryHandler, primaryAnalytics, secondaryTextKey, secondaryHandler, secondaryAnalytics } = useHandlers();
    if (shouldNotRender) {
        return null;
    }
    return (_jsxs(FooterWrapper, { children: [_jsx(Button, Object.assign({ "data-cy": "replacement-card-modal-primary-button", "data-testid": "primary-button", buttonType: "primary", onClick: activeStep === 'ExitConfirmation'
                    ? () => handleProfileClick(accountId)
                    : primaryHandler, "data-analytics": primaryAnalytics.dataAnalytics || 'clicktrackingevent', "data-title": primaryAnalytics.dataTitle, "data-object": primaryAnalytics.dataObject, "data-reason": primaryAnalytics.dataReason, "data-type": primaryAnalytics.dataType }, { children: t(primaryTextKey) })), secondaryTextKey && (_jsx(Button, Object.assign({ "data-cy": "replacement-card-modal-secondary-button", "data-testid": "secondary-button", buttonType: "ghost", onClick: secondaryHandler, "data-analytics": (secondaryAnalytics === null || secondaryAnalytics === void 0 ? void 0 : secondaryAnalytics.dataAnalytics) || 'clicktrackingevent', "data-title": secondaryAnalytics === null || secondaryAnalytics === void 0 ? void 0 : secondaryAnalytics.dataTitle, "data-object": secondaryAnalytics === null || secondaryAnalytics === void 0 ? void 0 : secondaryAnalytics.dataObject, "data-reason": secondaryAnalytics === null || secondaryAnalytics === void 0 ? void 0 : secondaryAnalytics.dataReason, "data-type": secondaryAnalytics === null || secondaryAnalytics === void 0 ? void 0 : secondaryAnalytics.dataType }, { children: t(secondaryTextKey) })))] }));
};
export default ModalFooter;
//# sourceMappingURL=index.js.map